/* unplugin-vue-components disabled */import { render } from "./latestActivity.vue?vue&type=template&id=5fe894ce&scoped=true"
import script from "./latestActivity.vue?vue&type=script&lang=js"
export * from "./latestActivity.vue?vue&type=script&lang=js"

import "./latestActivity.vue?vue&type=style&index=0&id=5fe894ce&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-案例中心-哈工程-前台页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe894ce"]])

export default __exports__